import i18next from 'i18next';

i18next.addResources('es', 'FileDropzone', {
  dropHere: 'Arrastre aquí',
  dragOrClick: 'Arrastre un archivo o haga click aquí',
  supportedFormats: 'Formatos soportadodos: '
});
